import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-ranked-choice-res',
  templateUrl: './ranked-choice-res.component.html',
  styleUrls: ['./ranked-choice-res.component.scss']
})
export class RankedChoiceResComponent implements OnInit {
  pollInfo;
  pollOptions = [];
  pollResInfo;
  // optionNameList = [];
  tableData1 = [];
  pollMessage;
  optionNameList = ['Preference'];
  preference = ['1 st', '2 nd', '3 rd','4 th','5 th', '6 th', '7th', '8 th', '9 th'];

  constructor(
    public dialogRef: MatDialogRef<RankedChoiceResComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.pollInfo = data.poll;
    this.pollResInfo = data.pollRes;
    this.pollOptions = this.pollInfo.poll_options;
    this.pollMessage = this.pollInfo.poll.message;
    console.log(this.pollInfo);
   }

  ngOnInit(): void {
    //this.pollResInfo.user_ranking
    debugger;
    this.pollMessage = this.pollInfo.poll;
    console.log(this.pollMessage)
        if(this.pollOptions){
          let dataInsttance = {};
          for(var i=0; i< this.pollOptions.length; i++){
            this.optionNameList.push(this.pollOptions[i].name);
            let pref = this.preference[i];
            console.log(pref);
            dataInsttance['opt'] = pref;
            let valueInstance = [];
            for(var j=0; j< this.pollOptions.length; j++){
              let inst = {};
              if(this.pollResInfo.user_ranking[i] == this.pollOptions[j].name){
                inst = {val:true,disable:true};
              }else{
                inst = {val:false,disable:true};
              } 
              valueInstance.push(inst);
            }
            dataInsttance['value'] = valueInstance;
            this.tableData1.push(dataInsttance);
            valueInstance = [];
            dataInsttance = {};
          }
        }
  } 



  onClickNo(){
    this.dialogRef.close();
  }
}
